import { IconButton } from '../../components/buttons/IconButton';
import { useMissionVisibilityStore } from '../../store/useMissionVisibilityStore';
import { en } from '../../locales/en';
import { Eye, EyeOff } from '@untitledui/icons';

function MissionVisibilityButton() {
  const missionVisibility = useMissionVisibilityStore((state) => state.missionVisibility);
  const toggleMissionVisibility = useMissionVisibilityStore((state) => state.toggleMissionVisibility);

  const isShowingAll = missionVisibility === 'all';
  const icon = isShowingAll ? Eye : EyeOff;
  const title = isShowingAll
    ? en.missionVisibilityButton.showSelectedVehicleMissionTitle
    : en.missionVisibilityButton.showAllMissionsTitle;

  return <IconButton icon={icon} padding='8px' onClick={toggleMissionVisibility} title={title} />;
}

export default MissionVisibilityButton;
